export const mockTerminationAmount = {
  amount: 12345.78,
  terminationDate: "2021-11-15",
  paymentReference: "9004412660308168",
  paymentAccount: "191-9876",
};
